import { Button, Table } from "antd";
import { NotFound } from "../../../sources/svg/svg";
import { complexDigitToman, convertCurrencyToRial, regexFormater } from "../../../tools/tools";
import { useDealer } from "../../../tools/api";
import { ExportOutlined } from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../address";

function DCBulkResult({ bulk, setBulk, styles }) {
	const { completeDCPurchase } = useDealer();
	const navigator = useNavigate();
	const cTable = [
		{
			title: "شماره",
			dataIndex: "msisdn",
			key: "msisdn",
			width: 150,
		},
		{
			title: "مبلغ (تومان)",
			dataIndex: "amount",
			key: "amount",
			width: 150,
		},
		{
			title: "توضیحات",
			dataIndex: "description",
			key: "description",
			width: 150,
		},
		{
			title: "نتیجه عملیات",
			dataIndex: "result",
			key: "result",
			width: 200,
			render: (text, record) => (
				<div>
					{record.result === "ناموفق" ? (
						<div className={styles.row_button}>
							<span style={{ color: "red" }}>{text}</span>
							{" - "}
							<Button className="" onClick={() => handleRetry(record)} style={{ marginLeft: 8 }}>
								تلاش مجدد
							</Button>
						</div>
					) : record.result === "موفق" ? (
						<span style={{ color: "green" }}>{text}</span>
					) : (
						<span>{text}</span>
					)}
				</div>
			),
		},
	];

	const [isLoading, setIsLoading] = useState(false);

	const updateRecordStatus = (key, result) => {
		setBulk((prev) => {
			const bulks = prev.List.map((item) => (item.key === key ? { ...item, result } : item));
			return { ...prev, List: bulks };
		});
	};

	const processRecords = async (records) => {
		for (const record of records) {
			try {
				setIsLoading(true);
				const response = await completeDCPurchase({
					msisdn: record.msisdn,
					planid: process.env.REACT_APP_PLANID_CHARGE_WALLET_DC,
					chargeamount: convertCurrencyToRial(regexFormater(record.amount).removeComma() || 0),
				});
				if (response) {
					updateRecordStatus(record.key, "موفق");
				} else {
					updateRecordStatus(record.key, "ناموفق");
				}
			} catch (error) {
				console.error(error);
				setIsLoading(false);
			}
		}
	};

	const handleRetry = async (record) => {
		updateRecordStatus(record.key, "درحال پردازش");
		try {
			setIsLoading(true);
			const response = await completeDCPurchase({
				msisdn: record.msisdn,
				planid: process.env.REACT_APP_PLANID_CHARGE_WALLET_DC,
				chargeamount: convertCurrencyToRial(regexFormater(record.amount).removeComma() || 0),
			});
			if (response) {
				updateRecordStatus(record.key, <span style={{ color: "green" }}>موفق</span>);
			} else {
				updateRecordStatus(record.key, "ناموفق");
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	const handleExport = async () => {
		const excel = new Excel();
		let tempTable = bulk?.List.map(({ key, ...item }) => {
			return item;
		});
		const tempTitle = cTable.map(({ render, ...item }) => item);
		excel
			.addSheet("گزارش فعالسازی شارژ")
			.setTHeadStyle({
				fontSize: 12,
				fontWeight: "bold",
				textAlign: "center",
				border: true,
			})
			.setTBodyStyle({
				fontSize: 10,
				textAlign: "right",
				border: true,
			})
			.addColumns(tempTitle)
			.addDataSource(tempTable, { str2Percent: true, str2num: true })
			.saveAs("dc-bulk.xlsx");
	};
	return (
		<div className={styles.calAmount}>
			<div className={styles.row_amount}>
				<div>
					<div>تعداد رکورد:</div>
					<div>{bulk?.List?.length || 0}</div>
				</div>
				<div>
					<div>مجموع مبلغ شارژ:</div>
					<div>
						<span>{complexDigitToman(bulk?.calAmount || 0)}</span> تومان
					</div>
				</div>
				<div>
					<div>اعتبار کیف پول:</div>
					<div>
						<span>{complexDigitToman(bulk?.wallet || 0)}</span> تومان
					</div>
				</div>
				<div>
					{bulk?.wallet - bulk?.calAmount >= 0 ? (
						<Button disabled={isLoading} onClick={() => processRecords(bulk.List)} className="btn-normal btn-aptel">
							پردازش
						</Button>
					) : (
						<Button className="btn-normal btn-aptel" onClick={(e) => navigator(_adr.Root + _adr.Wallet.Index + _adr.Wallet.WalletList)}>
							افزایش کیف پول
						</Button>
					)}
				</div>
			</div>
			{bulk?.wallet - bulk?.calAmount < 0 && (
				<div>
					<p style={{ color: "red" }}>اعتبار کیف پول شما کمتر از مبلغ شارژ است لطفا کیف پول خود را شارژ نمایید</p>
				</div>
			)}
			<div className={styles.holder_button}>
				<Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
					{" "}
					خروجی اکسل{" "}
				</Button>
			</div>
			<div className="holder-table">
				<Table
					className="tbl-normal"
					columns={cTable}
					pagination={false}
					locale={{
						emptyText: (
							<>
								<NotFound text={"رکوردی یافت نشد."} />
							</>
						),
					}}
					scroll={{ y: "100%" }}
					dataSource={bulk?.List}></Table>
			</div>
		</div>
	);
}

export default DCBulkResult;
